import { ApiError } from "../api/client";

/** A message worth showing a participant, whatever was thrown. */
export function messageOf(error: unknown): string {
  if (error instanceof ApiError || error instanceof Error) return error.message;
  return "Something went wrong. Try again.";
}

/** Runs `work`, tracking busy state and turning failures into a message instead of an unhandled rejection. */
export async function attempt<T>(
  setBusy: (busy: boolean) => void,
  setError: (message: string | null) => void,
  work: () => Promise<T>,
): Promise<T | undefined> {
  setBusy(true);
  setError(null);
  try {
    return await work();
  } catch (error) {
    setError(messageOf(error));
    return undefined;
  } finally {
    setBusy(false);
  }
}
